export const profileActionTypes = {
	PROFILE_CUSTOMER_REQUEST: 'PROFILE_CUSTOMER_REQUEST',
	PROFILE_CUSTOMER_SUCCESS: 'PROFILE_CUSTOMER_SUCCESS',
	PROFILE_CUSTOMER_FAILURE: 'PROFILE_CUSTOMER_FAILTURE',

	PROFILE_STORAGE_REQUEST: 'PROFILE_STORAGE_REQUEST',
	PROFILE_STORAGE_SUCCESS: 'PROFILE_STORAGE_SUCCESS',
	PROFILE_STORAGE_FAILURE: 'PROFILE_STORAGE_FAILURE',

	PROFILE_STATS_REQUEST: 'PROFILE_STATS_REQUEST',
	PROFILE_STATS_SUCCESS: 'PROFILE_STATS_SUCCESS',
	PROFILE_STATS_FAILURE: 'PROFILE_STATS_FAILURE',

	PROFILE_ACCEPT_TERMS: 'PROFILE_ACCEPT_TERMS'
};



// WEBPACK FOOTER //
// ./src/profile/actions/profile-action-types.js